<template>
  <div ref="wordcloudContainer" class="top-right-cmp">
    <div class="chart-name" :style="{color: Global.globalColor}">
      {{title}}
      <dv-decoration-3 style="width: calc(100vw * 260 / 1920); height: calc(100vw * 20 / 1920);"  :color="[Global.globalColor ,'#E0E1E2']" />
    </div>
    <!-- <dv-charts :option="option1" /> -->
    <div v-if="true" style="height: 100%" id="Buttonleftmain"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
//import bus from "../../unit/bus";
export default {
  name: "TopRightCmp",
  data () {
    return {
      caseID: localStorage.getItem("caseId"),
      option1: {},
      finandata: {},
      title:'',
      option: {
        title: {
          text: "",
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          orient: "horizontal",
          top: "85%",
          textStyle: {},
          data: [],
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "15%",
          top: "20%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
          minInterval:1
        },
        series: [],
        StateTypeList: [],
        ClassList: [],
      },
    };
  },
  created () {
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
    }),
  },
  watch: {
    Round (val) {
      console.log(val);
    },
  },

  mounted () {
   this.loadmd();
  },
  methods: {
    loadmd () {
      let that = this;
      that.$http
        .get(
          `FinanceStatistics/GetIncomeExpenditure?round=${that.Round}`
        )
        .then((res) => {
          if (res.success) {
            if (res.dynamicObj == null) return;
            that.finandata = res.dynamicObj;
            this.title=res.dynamicObj.title
            this.$nextTick((_) => {
              console.log(_)
              var mychart = this.echarts.init(document.getElementById("Buttonleftmain"));
              mychart.clear();
              this.option.xAxis.data = res.dynamicObj.xAxisList;
              this.option.legend.data = res.dynamicObj.legendList;
              this.option.legend.itemHeight = this.$refs.wordcloudContainer.clientWidth * 32 / 1920,
              this.option.legend.itemWidth = this.$refs.wordcloudContainer.clientWidth * 58 / 1920,
              this.option.legend.textStyle.fontSize = this.$refs.wordcloudContainer.clientWidth * 32 / 1920,
              this.option.series = res.dynamicObj.seriesList;
            // that.option1 = {
            //   legend: {
            //     type: 'scroll',
            //         bottom:'11%',
            //         height: '20',
            //     data:res.dynamicObj.legendList,
            //     textStyle: {
            //     },
            //   },
            //   xAxis: {
            //     data: res.dynamicObj.xAxisList,
            //     axisLine: {
            //       style: {
            //         stroke: "#999",
            //       },
            //     },
            //     axisLabel: {
            //       style: {
            //         fill: "#999",
            //       },
            //     },
            //     axisTick: {
            //       show: false,
            //     },
            //   },
            //   yAxis: {
            //     data: "value",
            //     splitLine: {
            //       show: false,
            //     },
            //     axisLine: {
            //       style: {
            //         stroke: "#999",
            //       },
            //     },
            //     axisLabel: {
            //       style: {
            //         fill: "#999",
            //       },
            //     },
            //     axisTick: {
            //       show: false,
            //     },
            //     min: 0
            //   },
            //   series:res.dynamicObj.seriesList,
            //   color:  this.Global.chartColor
            //   // series: [
            //   //   {
            //   //     name: "营业收入",
            //   //     data: that.finandata.income,
            //   //     type: "bar",
            //   //   },
            //   //   {
            //   //     name: "营业支出",
            //   //     data: that.finandata.pay,
            //   //     type: "bar",
            //   //   },
            //   // ],
            // };
              this.$nextTick(() => {
                  mychart.setOption(this.option);
                  window.onresize = function () {
                    mychart.resize();
                  };
                })
              })
          } else {
            this.$message.warning(res.message);
          }
        });
    },
  },
};
</script>

<style lang="less">
.top-right-cmp {
  position: relative;
  padding: 0 50px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  .chart-name {
    position: absolute;
    right: calc(100vw * 50 / 1920);
    text-align: right;
    font-size:calc(100vw * 22 / 1920);
    top: calc(100vw * 10 / 1920);
  }
}
.dv-charts-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.dv-charts-container .charts-canvas-container {
  width: 100%;
  height: 100%;
}
</style>
